// **************************************************
// Banner Animation
// **************************************************
const bannerModule = document.querySelectorAll('.banner-module');

bannerModule.forEach((el) => {
  const background = el.querySelector('.banner-module__image-inner');

  gsap.to(background, {
    yPercent: windowWidth() < breakpointMd ? 30 : 60,
    autoAlpha: 0.4,
    scrollTrigger: {
      trigger: el,
      start: 'top top',
      end: 'bottom+=100% top',
      scrub: true,
    },
  });
});

/* activeFilterCategorySlugsArray */
// **************************************************
// Category Filter
// **************************************************
const bannerButton = document.querySelector('.banner-module__button-group');
const articleCardList = document.querySelector('.sc-article-card-list');

if (bannerButton && articleCardList) {
  const ajaxResponseHtml = (response) => {
    const parentEle = document.querySelector('.sc-article-card-list');
    const listBody = parentEle.querySelector('.article-card-list__inner');

    if (response.status === 200) {
      listBody.innerHTML = '';
      const notFound = document.querySelector('.article-card-list__not-found-post');
      if (response.data.data.posts.length > 0) {
        notFound.classList.add('d-xs-none');
        response.data.data.posts.forEach((posts) => {
          listBody.innerHTML += `${posts}`;
        });
      } else {
        notFound.classList.remove('d-xs-none');
      }
    }
  };

  const sendPeoplePostModalAjax = (categorySlugs) => {
    const ajaxData = new FormData();
    ajaxData.append('action', 'getArticleCardListCategoryFilter');
    ajaxData.append('categorySlug', categorySlugs);
    ajaxData.append('lang', localData.lang);
    ajaxData.append('id', localData.id);
    window.history.replaceState(null, null, `?blog-category=${categorySlugs}`);

    axios
      .post(localData.siteURL, ajaxData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
      .then((response) => {
        ajaxResponseHtml(response);
      })
      .catch((err) => {
        console.error(err);
      });
  };

  // **************************************************
  // Filter posts by category
  // **************************************************
  const activeFilterCategorySlugsArray = () => {
    let categorySlugs = '';
    document.querySelectorAll('.banner-module__button-group .blog-category').forEach((link) => {
      if (link.classList.contains('ghost')) {
        categorySlugs += `${link.getAttribute('data-category-slug')}|`;
      }
    });
    return categorySlugs.slice(0, -1);
  };

  attachEvent('.banner-module__button-group .blog-category', 'click', (ev) => {
    ev.target.classList.toggle('ghost');

    const categorySlugs = activeFilterCategorySlugsArray();
    sendPeoplePostModalAjax(categorySlugs);
  });

  // **************************************************
  // Filter posts by category from URL
  // **************************************************
  window.addEventListener('load', () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const categorySlugs = urlSearchParams.get('blog-category');
    if (categorySlugs) {
      sendPeoplePostModalAjax(categorySlugs);
    }
  });
}
